var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "rb-banner",
    _vm._b(
      {
        directives: [
          {
            name: "view",
            rawName: "v-view",
            value: _vm.onViewportIntersection,
            expression: "onViewportIntersection",
          },
        ],
        ref: "banner",
        staticClass: "rb-gender-module",
        attrs: {
          "content-position": "bottom-center",
          autoplay: _vm.autoplay,
          loop: true,
          muted: true,
          size: "xsmall",
          controls: false,
          "start-video-on-hover": true,
          "stacked-on-mobile": true,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "image",
              fn: function () {
                return [_vm._t("image")]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [_vm._t("title")]
              },
              proxy: true,
            },
            {
              key: "title_block",
              fn: function () {
                return [_vm._t("title_block")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "rb-banner",
      Object.assign({}, _vm.$props, _vm.$attrs),
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }